export interface ClackSkuConfig {
  sku: string;
  minimumQuantity: number | null;
  maximumQuantity: number | null;
  minimumTaskQuantity: number | null;
}

export interface ClackData {
  skuConfigs: ClackSkuConfig[];
}

export const CLACK_REPLENISHMENT_TASK_NOTE = 'clack replenishment';

export const DEFAULT_CLACK_DATA: ClackData = {
  skuConfigs: [
    {
      sku: 'C1030-00-159',
      minimumQuantity: null,
      maximumQuantity: null,
      minimumTaskQuantity: null,
    },
    {
      sku: 'C1040-00-159',
      minimumQuantity: null,
      maximumQuantity: null,
      minimumTaskQuantity: null,
    },
    {
      sku: 'C1050-00-159',
      minimumQuantity: null,
      maximumQuantity: null,
      minimumTaskQuantity: null,
    },
  ],
};
